// extracted by mini-css-extract-plugin
module.exports = {"text":"heroSkins-noMargin-text-7bae419e"};